import React from "react";
import { Translate } from "react-localize-redux";

import { Loader } from "@pages/casino/components";

import { LoadingContainer, LoadingOverlay } from "./elements";
import { setLoadingName } from "./utils";

const TabLoading = ({ loading, loadingType }) => {
	if (window.TENANT === "betto") {
		return null;
	}

	return (
		<Translate>
			{({ translate }) => (
				<>
					<LoadingOverlay
						className="loading-overlay"
						loading={loading}
					/>
					{loading && (
						<LoadingContainer>
							<Loader />
							<p>
								{setLoadingName(translate, loadingType)
									? `${setLoadingName(translate, loadingType)}...`
									: ""}
							</p>
						</LoadingContainer>
					)}
				</>
			)}
		</Translate>
	);
};

export default TabLoading;
